import GroupAddIcon from '@material-ui/icons/GroupAdd';
import UserList from './UserList';
import UserCreate from './UserCreate';

export default {
    list: UserList,
    create: UserCreate,
    icon: GroupAddIcon,
};
